import * as React from "react"
import { useState } from "react"
import { saTypeFaqItem } from "../saTypes"



type saTypeFaqListClass = {
  list?: string,
  item?: string,
  q?: string,
  a?: string
}


const SaFaqListItem: any = (props) => {



  const [isActive, setIsActive] = useState(false);

  return(
    <div className={props.classes.item || 'saFaqListItem'}
         onClick={() => setIsActive(!isActive)}>

      <div className={props.classes.q || 'saQ'}
           dangerouslySetInnerHTML={{__html: props.q}}
      />

      {
        isActive &&
        <div className={props.classes.a || 'saA'}
             dangerouslySetInnerHTML={{__html: props.a}}
        />
      }

    </div>
  )
}


const SaFaqList: any = (props) =>  {


    if (!props.faq) return null


    let classes: saTypeFaqListClass = props.classes

    let list = Object.values(props?.faq)

    let listItems = list.map((item : saTypeFaqItem,index)  => (

        <SaFaqListItem
          key={index}
          classes={classes}
          q={item.q}
          a={item.a}
        />

      )
    )

    return (
      <div className={classes.list || 'saFaqListItem'}>
            {listItems}
      </div>
    )

}

export default SaFaqList